var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'col-12 col-md-6 mb-4':!_vm.$props.full}},[_c('h1',[_c('a',{staticClass:"text-secondary"},[_vm._t("title")],2)]),_vm._t("intro")],2)}
var staticRenderFns = []

export { render, staticRenderFns }